export default __webpack_public_path__ + "static/great-gatsby-landscape-02fc11b9745942db6a5bdd7055f8e2cc.jpg";